module.exports = __webpack_public_path__ + "static/media/no-result.86f37514.svg";